module.exports = __webpack_public_path__ + "static/media/i3-sick.a4712448.png";